import { createContext, useContext } from "react";

export type Timezone = "WAT" | "EAT";
export const TimezoneContext = createContext<{ zone: Timezone; setZone: (zone: Timezone) => void }>(
  { zone: "WAT", setZone: () => {} },
);
export function useTimezone() {
  return useContext(TimezoneContext);
}
